import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { TaskAggregateRowDto } from "@gw/shared-types";
import { aggregateTasks, type AggregateTasksParams } from "@/api/endpoints";

export function useTaskAggregateQuery(params: AggregateTasksParams) {
  return useQuery<TaskAggregateRowDto[]>({
    queryKey: ["tasks", "aggregate", params],
    queryFn: () => aggregateTasks(params),
    staleTime: 60_000,
    enabled: params.groupBy.length > 0,
    placeholderData: keepPreviousData,
  });
}
